// SEO data for different pages
export const seoConfig = {
  home: {
    title: 'Winnomi AI - AI Destekli sosyal medya Analitik Platformu',
    description:
      'AI destekli sosyal medya analitik platformu ile işletmenizi büyütün. Instagram, Facebook, Twitter, LinkedIn ve TikTok analitiği tek platformda. Gerçek zamanlı veriler, AI önerileri ve kapsamlı raporlama.',
    keywords:
      'sosyal medya analitik, instagram analitik, facebook analitik, twitter analitik, linkedin analitik, tiktok analitik, AI analiz, sosyal medya yönetimi, sosyal medya pazarlama, sosyal medya raporlama, sosyal medya metrikleri',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Winnomi AI',
        url: 'https://winnomi.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'https://winnomi.com/search?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'Winnomi AI',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'TRY',
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.8',
          ratingCount: '150',
        },
      },
    ],
  },
  login: {
    title: 'Giriş Yap - Winnomi AI',
    description: 'Winnomi AIhesabınıza giriş yapın ve sosyal medya analitik platformunuzu kullanmaya başlayın.',
    keywords: 'winnomi giriş, sosyal medya analitik giriş, hesap girişi',
    noindex: true,
  },
  register: {
    title: 'Kayıt Ol - Winnomi AI',
    description: 'Winnomi AI hesabı oluşturun ve AI destekli sosyal medya analitik platformunu ücretsiz deneyin.',
    keywords: 'winnomi AI kayıt, ücretsiz hesap, sosyal medya analitik kayıt',
    noindex: true,
  },
  emailVerification: {
    title: 'Email Doğrulama - Winnomi AI',
    description: 'Email adresinizi doğrulayın ve hesabınızı aktifleştirin.',
    keywords: 'email doğrulama, hesap doğrulama, email onayı',
    noindex: true,
  },
  terms: {
    title: 'Kullanım Koşulları - Winnomi AI',
    description: 'Winnomi AI platformu kullanım koşulları ve hizmet şartları.',
    keywords: 'kullanım koşulları, hizmet şartları, winnomi AI şartlar',
  },
  privacy: {
    title: 'Gizlilik Politikası - Winnomi AI',
    description: 'Winnomi AI gizlilik politikası ve kişisel verilerin korunması hakkında bilgiler.',
    keywords: 'gizlilik politikası, kişisel veri koruma, KVKK',
  },
  kvkk: {
    title: 'KVKK Aydınlatma Metni - Winnomi AI',
    description: 'Winnomi AI KVKK aydınlatma metni ve kişisel verilerin işlenmesi hakkında bilgiler.',
    keywords: 'KVKK, aydınlatma metni, kişisel veri işleme',
  },
  dashboard: {
    title: 'Dashboard - sosyal medya Analitiği | Winnomi AI',
    description: 'sosyal medya hesaplarınızın performansını tek bir dashboard üzerinden takip edin.',
    keywords: 'sosyal medya dashboard, analitik dashboard, performans takibi',
    noindex: true,
  },
  analytics: {
    title: 'Analitik - sosyal medya Analizi | Winnomi AI',
    description: 'Detaylı sosyal medya analitik raporları ve metrikleri ile performansınızı ölçün.',
    keywords: 'sosyal medya analitik, analitik raporlar, metrikler, performans analizi',
    noindex: true,
  },
  audience: {
    title: 'Hedef Kitle Analizi | Winnomi AI',
    description: 'sosyal medya hedef kitlenizi analiz edin ve demografik bilgileri keşfedin.',
    keywords: 'hedef kitle analizi, demografik analiz, kitle segmentasyonu',
    noindex: true,
  },
  engagement: {
    title: 'Etkileşim Analizi | Winnomi AI',
    description: 'sosyal medya etkileşim metriklerinizi takip edin ve içerik performansını ölçün.',
    keywords: 'etkileşim analizi, engagement metrikleri, içerik performansı',
    noindex: true,
  },
  instagram: {
    title: 'Instagram Analitik | Winnomi AI',
    description: 'Instagram hesabınızın detaylı analitik raporları, takipçi analizi ve içerik performansı.',
    keywords: 'instagram analitik, instagram raporları, instagram takipçi analizi',
    noindex: true,
  },
  facebook: {
    title: 'Facebook Analitik | Winnomi AI',
    description: 'Facebook sayfa ve reklam performansınızı analiz edin ve detaylı raporlar alın.',
    keywords: 'facebook analitik, facebook raporları, facebook sayfa analizi',
    noindex: true,
  },
  twitter: {
    title: 'Twitter Analitik | Winnomi AI',
    description: 'Twitter hesabınızın performans metriklerini takip edin ve tweet analizleri yapın.',
    keywords: 'twitter analitik, twitter raporları, tweet analizi',
    noindex: true,
  },
  linkedin: {
    title: 'LinkedIn Analitik | Winnomi AI',
    description: 'LinkedIn sayfa ve içerik performansınızı analiz edin ve profesyonel ağınızı büyütün.',
    keywords: 'linkedin analitik, linkedin raporları, linkedin sayfa analizi',
    noindex: true,
  },
  tiktok: {
    title: 'TikTok Analitik | Winnomi AI',
    description: 'TikTok hesabınızın performans metriklerini takip edin ve video analizleri yapın.',
    keywords: 'tiktok analitik, tiktok raporları, tiktok video analizi',
    noindex: true,
  },
  aiPredictions: {
    title: 'AI Tahminler - Gelecek Performans Analizi | Winnomi AI',
    description: 'Yapay zeka destekli tahminler ile sosyal medya performansınızın geleceğini öngörün.',
    keywords: 'AI tahminler, yapay zeka analiz, performans tahmini, makine öğrenmesi',
    noindex: true,
  },
  aiRecommendations: {
    title: 'AI Önerileri - Akıllı İçerik Önerileri | Winnomi AI',
    description: 'Yapay zeka destekli öneriler ile sosyal medya stratejinizi optimize edin.',
    keywords: 'AI önerileri, yapay zeka önerileri, içerik önerileri, strateji optimizasyonu',
    noindex: true,
  },
  webTraffic: {
    title: 'Web Trafiği Analizi | Winnomi AI',
    description: 'Web sitenizin trafik metriklerini analiz edin ve ziyaretçi davranışlarını takip edin.',
    keywords: 'web trafiği, trafik analizi, ziyaretçi analizi, web analitik',
    noindex: true,
  },
  webEngagement: {
    title: 'Web Etkileşim Analizi | Winnomi AI',
    description: 'Web sitenizdeki kullanıcı etkileşimlerini ölçün ve optimize edin.',
    keywords: 'web etkileşim, kullanıcı etkileşimi, sayfa etkileşimi',
    noindex: true,
  },
  adsOverview: {
    title: 'Reklam Analitiği Özeti | Winnomi AI',
    description: 'Tüm reklam kampanyalarınızın performansını tek bir yerden takip edin.',
    keywords: 'reklam analitik, kampanya analizi, reklam performansı',
    noindex: true,
  },
  adsConversions: {
    title: 'Reklam Dönüşümleri | Winnomi AI',
    description: 'Reklam kampanyalarınızın dönüşüm metriklerini analiz edin.',
    keywords: 'reklam dönüşümleri, conversion tracking, dönüşüm analizi',
    noindex: true,
  },
  integrations: {
    title: 'Entegrasyonlar | Winnomi AI',
    description: 'sosyal medya hesaplarınızı ve araçlarınızı Winnomi AI ile entegre edin.',
    keywords: 'sosyal medya entegrasyonu, API entegrasyonu, platform entegrasyonu',
    noindex: true,
  },
  settings: {
    title: 'Ayarlar | Winnomi AI',
    description: 'Hesap ayarlarınızı ve tercihlerinizi yönetin.',
    keywords: 'hesap ayarları, profil ayarları, tercihler',
    noindex: true,
  },
  notifications: {
    title: 'Bildirimler | Winnomi AI',
    description: 'Bildirimlerinizi görüntüleyin ve yönetin.',
    keywords: 'bildirimler, uyarılar, bildirim ayarları',
    noindex: true,
  },
  services: {
    title: 'Hizmetler - sosyal medya Analitik ve AI Araçları | Winnomi AI',
    description: 'Instagram, Facebook, Twitter, LinkedIn, TikTok analitik hizmetleri ve AI destekli öngörüler ve öneriler. sosyal medya performansınızı optimize edin.',
    keywords: 'sosyal medya analitik, Instagram analitik, Facebook analitik, Twitter analitik, LinkedIn analitik, TikTok analitik, AI öngörüleri, AI önerileri',
  },
};

// Helper function to generate breadcrumb JSON-LD
export const generateBreadcrumbJsonLd = (items: Array<{ name: string; url: string }>) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
};

// Helper function to generate FAQ JSON-LD
export const generateFAQJsonLd = (faqs: Array<{ question: string; answer: string }>) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
};

